import { AuthenticationGurad } from './authenticate.guard';
import { AuthorizationGurad } from './authorization.gurad';

export const GUARD_PROVIDERS = [AuthenticationGurad, AuthorizationGurad];

export { AuthenticationGurad, AuthorizationGurad };
